import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {confirmAlert} from "react-confirm-alert";
import ReactToPrint from "react-to-print";
import ProductLong from "components/Labels/ProductLong";
import ProductShort from "components/Labels/ProductShort";
import ObjectOverride from "components/ObjectOverride";
import Access from "constants/Access";
import {PrintBarcodeModal} from '../../containers/Print';
import TextField from "@material-ui/core/TextField";
import API from "@beardeddevops/react.api";
import Tooltip from "@material-ui/core/Tooltip";
import {Objects, Parts} from "../index";
import UniversalModalOverride from "../UniversalModalOverride";
import InventoryModal from "../Parts/GunsAmericaModal";
import ProductFinishFields from "./ProductFinishFields";


/**
 *  @property {Products_Object} state
 *  @property {object} model
 *  @property {Products_Properties} model.properties
 *  @property {Products_Is} model.is
 *  @property {Products_Has} model.has
 */

class ProductUpdateObject extends ObjectOverride {
	constructor(props) {
		super(props, Types.Products._name);
		//this.model.serial_number.ux_validation = false;
		this.printLabel = this.printLabel.bind(this)
		this.state.bound_book_note = '';
		this.state.modal = false;
		this.state.atfModalPop = null;
		this.state.gunbrokerModal = false;
		this.state.ammoreadyModal = false;
		this.state.updatedProduct = {};

	}

	shortLabelRef = null;
	longLabelRef = null;

	/**
	 * @param prevProps
	 * @param {Products_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate (prevProps, prevState, snapshot)  {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		/** @type {Products_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.serial_number);
		}

	}

	componentDidMount() {
		super.componentDidMount();
		this.state.atfRequired = ['serial_number',  'manufacturer',  'manufacturer_other',  'model',  'barrel_length',  'overall_length',
		 'acquisition',  'type',  'importer',  'model',  'caliber',  'caliber_other'];
	}


	printLabel() {
		let object = this.state
		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintBarcodeModal
						onClose={onClose}
						longBarCode={<ProductLong product={object}/>}
						shortBarCode={<ProductShort product={object}/>}
						showFullLabel={true}
					/>
				);
			}
		});
	}

	handleModalSave = async () => {
		await super.handleSubmit();
		this.toggle();
		this.state.change_note = '';
	}

	handleModalToggle = async () => {
		if(this.state.atfModalPop) {
			this.toggle()
			this.state.atfModalPop = false
		}
		else {
			await super.handleSubmit();
		}
	}

	toggle = () => {
		this.setState({modal: !this.state.modal})
	}

	handleTextFieldOverride = (e, value) => {
		this.handleTextFieldPropertyUpdate(e, value);
		if(this.state.atfRequired.includes(e)) {
			this.state.atfModalPop = true;
		}
	}

	handleSelectOverride = (e, value) => {
		if(this.state.manufacturer_copy !== this.state.manufacturer || this.state.caliber_copy !== this.state.caliber && this.state.type_copy !== this.state.type) {
			this.state.atfModalPop = true;
		}
		this.handleSelectPropertyUpdate(e, value)
	}

	handleSubmit = () => {
		this.toggle();
	}

	handleGunbrokerUpload = async () => {
		this.setState({loading: true})
		this.setState({gunbrokerModal: true, loading: false})
	}

	handleAmmoReadyUpload = async () => {
		this.setState({ammoreadyModal: true})
	}


	handleGunsAmericaUpload = async () => {
		this.setState({isModalOpen: true})
	}

	handleGunsAmericaUpdate = async () => {
		this.setState({loading: true})
		let pModel = new API.BuildClass(Types.Products._name, 'GET_GUNSAMERICA_PRODUCT');
		pModel.object.id = this.state.gunsamerica_stock_number;
		let result = await pModel.submit(null, 'GET_GUNSAMERICA_PRODUCT')
		if(result) {
			this.setState({updatedProduct: result});
			await this.handleGunsAmericaUpload()
		}
		this.setState({loading: false})
		this.refreshPage();
	}

	toggleModal = () => {
		this.setState({isModalOpen: !this.state.isModalOpen})
	}


	/**
	 *
	 * @param modal
	 */
	handleReportClose = (modal) => {
		this.setState({[modal]: false});
	}


	displaySkuAndUpcField() {
		if(this.props.rootState.account_number === 3281 || this.state.locations.has_gunsamerica_module) {
			return (
				<>
					<div className="form-group">
						<Framework.Elements.TextField
							label={"SKU"}
							value={this.state.sku}
							error={this.state.sku_error}
							property={this.model.properties.sku}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>
					<div className={"row"}>
						<div className={"col-md-12"}>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"UPC"}
									value={this.state.upc}
									error={this.state.upc_error}
									property={this.model.properties.upc}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</>
			)
		}
		return (
			<div className="form-group">
				<Framework.Elements.TextField
					label={"SKU"}
					value={this.state.sku}
					error={this.state.sku_error}
					property={this.model.properties.sku}
					update={this.handleTextFieldPropertyUpdate}
				/>
			</div>
		)
	}


	form = () => {
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;
		let {loading} = this.state;
		let exists = object.pkey;
		//probably some higher level function in js that can do this like a filter or reduce
		let has_michigan_module = false;
		let has_dr_7602_module = false;
		if (Array.isArray(this.props.locations)) {
			for(const loc of this.props.locations) {
				if(loc.pkey === object.location) {
					has_michigan_module = loc.has_michigan_module === true;
					has_dr_7602_module = loc.has_dr_7602_module === true;
					break;
				}
			}
		}

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							{/*#region ATF Regulated Information*/}
							<h4 className="section-title">ATF Regulated Information</h4>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Serial Number"}
									value={object.serial_number}
									error={object.serial_number_error}
									property={properties.serial_number}
									update={this.handleTextFieldOverride}
								/>
							</div>
							{/*#endregion*/}
							{/*#region Inventory Management*/}
							<h4 className="section-title">Inventory Management</h4>

							{/*Location*/}
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
								disabled={true}
								hideLabel={true}
							/>

							{object.location && <div className="form-group">
								<Framework.Elements.Select
									objectKey={object.location_binary_id + '-' + object.location}
									parent={object.location_binary_id + '-' + object.location}
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.bound_book}
									value={object.bound_book}
									binary_id={object.bound_book_binary_id}
									error={object.bound_book_error}
									object={object.location_bound_books}
									nullable={true}
									default={{
										value: "",
										label: object.locations_related_by_location ? object.locations_related_by_location.bound_book : 'Primary'
									}}
									disabled={true}
								/>
							</div>}

							{/*Status*/}
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={true}
									property={properties.status}
									value={object.status}
									error={object.status_error}
									object={object.product_statuses}
									update={this.handleSelectPropertyUpdate}
									nullable={true}
									disabled={true}
								/>
							</div>

							<div className={"row"}>
								<div className={"col-md-4"}>
									<h4 className="section-title">Cost</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Cost"}
											value={object.cost}
											error={object.cost_error}
											property={properties.cost}
											update={this.handleTextFieldOverride}
										/>
									</div>
								</div>
								{this.props.rootState.account_number !== 880 ?
									<div className={"col-md-4 pl-0"}>
										<h4 className="section-title">Min Price</h4>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Min Price"}
												value={object.price_min}
												error={object.price_min_error}
												property={properties.price_min}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div> :
									<div className={"col-md-4"}>
										<h4 className="section-title">Appraised Value</h4>
										<div className="form-group">
											<Framework.Elements.TextField
												label={"Appraisal"}
												value={object.appraisal_value}
												error={object.appraisal_value_error}
												property={properties.appraisal_value}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								}
								<div className={"col-md-4 pl-0"}>
									<h4 className="section-title">List Price</h4>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"List Price"}
											value={object.price_list}
											error={object.price_list_error}
											property={properties.price_list}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>

							</div>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Full Label Note"}
									value={object.tag_note}
									error={object.tag_note_error}
									property={properties.tag_note}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>

							<div className={"row"}>
								{this.state.locations.has_gunbroker_module && <Button
									color="warning"
									onClick={this.handleGunbrokerUpload}>
									Upload Product to GunBroker
								</Button>}
							</div>
							<div className={"row"} style={{marginTop: '20px'}}>
								{this.state.locations.has_ammoready_module && <Button
									color="warning"
									onClick={this.handleAmmoReadyUpload}>
									Upload Product to AmmoReady
								</Button>}
							</div>
							<div className={"row"} style={{marginTop: '20px'}}>
								{this.state.locations.has_gunsamerica_module ? object.gunsamerica_stock_number ? <Button
									color="success"
									onClick={this.handleGunsAmericaUpdate}>
									Update product on GunsAmerica
								</Button>
								:
									<Button
										color="warning"
										onClick={this.handleGunsAmericaUpload}>
										Upload Product to GunsAmerica
									</Button> : null
								}
							</div>

							{this.props.rootState.account_number === 880 &&
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.product_buyer}
									value={object.product_buyer}
									error={object.product_buyer_error}
									model={Types.Custom_Modules_Customs_880._name}
									requestOverride={"GET_BUYERS"}
									id={'pkey'}
									nullable={true}
									limit={null}
								/>
							}
							{/*#endregion*/}

						</div>

						<div className={"col-md"}>
							{/*#region ATF Required Information*/}
							<h4 className="section-title">ATF Required Information</h4>
							<div className="form-group" data-id="product-type">
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectOverride}
									property={properties.type}
									value={object.type}
									error={object.type_error}
									model={Types.Products_Types._name}
									id={'name'}
									nullable={false}
									limit={null}
								/>
							</div>
							{
								((object.type === 'Rifle' || object.type === 'Rifle / Shotgun') && this.props.locations.some((location) => {
									let borderStates = ["AZ", "TX", "NV", "CA"]
									return borderStates.includes(location.state)
								})) &&
								<div style={{marginTop: '-10px', marginBottom: '1rem', textAlign: 'right'}}>
									<p style={{marginBottom: '2px', color: 'grey', fontStyle: 'italic', fontSize: '12px'}}>Semi-automatic rifle with a
										detachable magazine?</p>
									<Framework.Elements.ButtonSwitch
										property={properties.semi_auto_w_detach}
										value={object.semi_auto_w_detach}
										error={object.semi_auto_w_detach_error}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={'Yes'}
										labelFalse={'No'}
									/>
								</div>
							}
							<div className="form-group">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectOverride}
									property={properties.manufacturer}
									value={object.manufacturer}
									error={object.manufacturer_error}
									model={Types.Manufacturers._name}
									nullable={true}
									limit={null}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.manufacturer_other}
									error={object.manufacturer_other_error}
									property={properties.manufacturer_other}
									update={this.handleTextFieldOverride}
									label={"Manufacturer (Manual Entry)"}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Importer (If Imported)"}
									value={object.importer}
									error={object.importer_error}
									property={properties.importer}
									update={this.handleTextFieldOverride}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Model"}
									value={object.model}
									error={object.model_error}
									property={properties.model}
									update={this.handleTextFieldOverride}
								/>
							</div>
							<div className="form-group" data-id="caliber">
								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectOverride}
									property={properties.caliber}
									value={object.caliber}
									error={object.caliber_error}
									object={object.calibers}
									nullable={true}
									default={{value: '', label: 'Other (Manual Entry)'}}
									defaultFirst={true}
								/>
							</div>
							{!object.caliber &&	<div className="form-group">
								<Framework.Elements.TextField
									label={"Caliber (Manual Entry)"}
									value={object.caliber_other}
									error={object.caliber_other_error}
									property={properties.caliber_other}
									update={this.handleTextFieldOverride}
								/>
							</div>}
							<div className={"row"}>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Barrel Length"}
											value={object.barrel_length}
											error={object.barrel_length_error}
											property={properties.barrel_length}
											update={this.handleTextFieldOverride}
										/>
									</div>
								</div>
								<div className={"col-md-6"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={"Overall Length"}
											value={object.overall_length}
											error={object.overall_length_error}
											property={properties.overall_length}
											update={this.handleTextFieldOverride}
										/>
									</div>
								</div>
							</div>

							{has_michigan_module ?

								<div>
									<h4 className="section-title">Michigan RI-060 Required Information</h4>
									<div className={"row"}>
										<div className={"col-md-6"}>
											<div className="form-group" style={{marginTop: -5}}>
												<Framework.Elements.Checkbox
													value={object.semi_auto}
													property={properties.semi_auto}
													error={object.semi_auto}
													update={() => (this.setState({semi_auto: !this.state.semi_auto}))}
													color="primary"
													label={'Semi-Auto'}
												/>
											</div>
										</div>
										{/*</div>*/}
										<div className="col-md-6 pl-0">
											<div className={"form-group"}>
												<Framework.Elements.TextField
													label={"State Overall Length"}
													value={object.state_oal}
													error={object.state_oal_error}
													property={properties.state_oal}
													update={this.handleTextFieldOverride}
												/>
											</div>
										</div>
									</div>
								</div>
								: null}
							{has_dr_7602_module &&
								<ProductFinishFields
									value={object.finish}
									update={(finish) => this.setState({finish})}
								/>
							}
							{/*#endregion*/}
						</div>
						<div className={"col-md"}>
							{/*#region Product Details*/}
							<h4 className="section-title">Product Details</h4>
							<div className="form-group">
								<div className="row">
									<div className="col-6">
										<span className="input-label">New/Used Item</span>
									</div>
									<div className="col-6 text-right">
										<Framework.Elements.ButtonSwitch
											property={properties.used_firearm}
											value={object.used_firearm}
											error={object.used_firearm_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'Used'}
											labelFalse={'New'}
										/>

									</div>
								</div>
								<div className="row" style={{marginTop: '15px'}}>
									<div className="col-6">
										<span className="input-label">Taxable</span>
									</div>
									<div className="col-6 text-right" style={{marginBottom: '15px'}}>
										<Framework.Elements.ButtonSwitch
											property={properties.taxable}
											value={object.taxable}
											error={object.taxable_error}
											update={this.handleTextFieldPropertyUpdate}
											labelTrue={'Yes'}
											labelFalse={'No'}
										/>

									</div>
								</div>
							</div>

							{this.displaySkuAndUpcField()}
							<div className="form-group">
								<Tooltip title={"(e.g. 12 + 1)"} placement={"left-start"}>
									<Framework.Elements.TextField
										label={"Shot (Magazine Capacity)"}
										value={object.shot}
										error={object.shot_error}
										property={properties.shot}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</Tooltip>
							</div>
							<div className="form-group">
								<Framework.Elements.TextField
									label={"Product Description"}
									value={object.item_description}
									error={object.item_description_error}
									property={properties.item_description}
									update={this.handleTextFieldPropertyUpdate}
									multiline={4}
								/>
							</div>
							{/*#endregion*/}

							<h4 className="section-title">Label Preview</h4>
							<div style={{textAlign: 'center'}}>
								<ProductLong product={object} visible={true}/>
							</div>

						</div>
					</div>

				</fieldset>


				<Framework.Elements.LoadingSpinner isLoading={loading}/>


				<Modal
					isOpen={this.state.modal}
					toggle={this.toggleClose}
					size={"md"}
					backdrop={true}
					keyboard={true}
				>


					<ModalHeader toggle={this.toggleClose}>
						{"Bound Book Note"}
					</ModalHeader>
					<ModalBody>
						<div className={"row"}>
						<div className={"col-12"}>
							<div className={"form-group"}>
								<TextField
									fullWidth={true}
									size={"medium"}
									label={"Bound Book Note"}
									value={this.state.change_note}
									onChange={(e) => this.setState({change_note: e.currentTarget.value})}
									variant="outlined"
								/>
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={this.toggle}>Cancel</Button>
					<Button color="primary" onClick={this.handleModalSave}>Save</Button>
				</ModalFooter>
			</Modal>
			</div>
		)
	}

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>

					<UniversalModalOverride
						locations={rootState.locations}
						states={rootState.states}
						history={this.props.history}
						name={"Gunbroker Required Information"}
						object={Objects.GunbrokerConfig}
						toggle={this.state.gunbrokerModal}
						reportClose={() => this.handleReportClose('gunbrokerModal')}
						afterSave={() => this.props.history.push('/products#foreign')}
						size={"xl"}
						objectProps={{
							shipping_profiles: this.state.shippingProfiles,
							product: this.state,
							postal_code: this.state.locations.zip
					}}
					/>


					<UniversalModalOverride
						locations={rootState.locations}
						states={rootState.states}
						history={this.props.history}
						name={"AmmoReady Information"}
						object={Objects.AmmoReadyConfig}
						toggle={this.state.ammoreadyModal}
						reportClose={() => this.handleReportClose('ammoreadyModal')}
						afterSave={() => this.props.history.push('/products#foreign')}
						size={"xl"}
						objectProps={{
							productInfo: this.state,
							handleModalClose: this.handleAmmoreadyClose
						}}
					/>

					<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>

					<InventoryModal isOpen={this.state.isModalOpen} toggle={this.toggleModal} product={this.state} updatedProduct={this.state.updatedProduct}/>
				</CardContent>
				<CardActions style={{justifyContent: 'flex-end', padding: '14px'}}>
					<Button color="default" onClick={this.printLabel} style={{marginRight: 'auto'}}>Print Label</Button>
					{this.props.rootState.userAccess <= Access.Manager && (!this.state.product_statuses|| this.state.product_statuses.pkey===8) &&
					<Button color="danger" onClick={this.handleDelete}>Delete</Button>}
					<Button color="primary" onClick={this.handleModalToggle}>Save
			</Button>
				</CardActions>

			</Card>


		)
	}
}

export default Framework.Components.withRootState(ProductUpdateObject);
